import { uniq } from 'lodash';
import {
  IAssembly,
  IComponent,
  IScheduleAssembly,
  IScheduleDaypart,
} from 'src/interfaces';

import { REVIEW_PAGE_COLUMN } from './BulkReplaceReviewPage.interface';

export const columns = [
  { label: '', key: REVIEW_PAGE_COLUMN.CHECK_BOX, width: 0 },
  { label: 'Assembly name', key: REVIEW_PAGE_COLUMN.ASSEMBLY_NAME, width: 340 },
  { label: 'Channel type', key: REVIEW_PAGE_COLUMN.CHANNEL_TYPE, width: 270 },
  {
    label: 'No of location groups',
    key: REVIEW_PAGE_COLUMN.NO_OF_LOCATION_GROUPS,
    width: 270,
  },
  { label: '', key: REVIEW_PAGE_COLUMN.TAGS, width: 500 },
  { label: '', key: REVIEW_PAGE_COLUMN.TOGGLE, width: 70 },
];

export const chooseTag = (
  replacementEnabled: boolean,
  isChildRow: boolean = false,
  checked: boolean,
  isInherited: boolean,
  stagedAssembly: { display_name: string[]; assembly_id: number },
  isParentChecked?: boolean | null,
) => {
  if (stagedAssembly?.display_name?.length > 0) {
    return `A bulk replace ${stagedAssembly.display_name[0]} for this assembly & component is already staged.`;
  } else if (isChildRow) {
    switch (isInherited) {
      case false:
        return checked
          ? replacementEnabled
            ? `The component will be replaced.`
            : 'The component you selected to replace does not exist on this assembly.'
          : `The variation does not inherit from it's original assembly, the component will not be replaced.`;
      case true:
        return isParentChecked
          ? replacementEnabled
            ? `The variation inherits from it's original assembly, the component will be replaced.`
            : `The component will not be replaced.`
          : 'The variation is inheriting from its original. The original was not selected, the component will not be replaced.';
      default:
        return `The variation does not inherit from it's original assembly, the component will not be replaced.`;
    }
  } else {
    switch (replacementEnabled) {
      case true:
        return checked
          ? 'The component will be replaced.'
          : 'The component will not be replaced.';
      default:
        return 'The component you selected to replace does not exist on this assembly.';
    }
  }
};

export const getSelectedAssembiles = (
  assembliesIds: number[],
  assemblies?: IAssembly[],
) => {
  const selectedassemblies = assemblies?.filter((assembly) =>
    assembliesIds.includes(assembly.id),
  );

  return selectedassemblies;
};

export const getChildInheritedIds = (
  assembliesList: IAssembly[] | undefined,
  allowedAssemblyIds: number[],
  selectedAssemblyIds: number[],
  selectedComponent: IComponent | undefined,
): number[] => {
  const childInheritedIds =
    assembliesList?.flatMap((assembly: IAssembly) =>
      assembly.childrenAssemblies
        .filter(
          ({ id, variation_parent_id, assemblyComponents }) =>
            allowedAssemblyIds?.includes(id) &&
            variation_parent_id !== null &&
            selectedAssemblyIds?.includes(variation_parent_id) &&
            allowedAssemblyIds?.includes(variation_parent_id) &&
            !assemblyComponents?.some(
              (item) => selectedComponent?.id === item.component_id,
            ),
        )
        .map(({ id }) => id),
    ) || [];

  return childInheritedIds;
};

export const getLocationCodes = (
  scheduleAssemblies: IScheduleAssembly[] | undefined,
  assemblyIds: number[],
) => {
  const locationCodes = [
    ...uniq(
      scheduleAssemblies
        ?.filter(
          (assembly) =>
            assemblyIds.includes(assembly.assembly_id) &&
            assembly.location_code !== null,
        )
        .map((assembly) => assembly.location_code),
    ),
  ];

  return locationCodes as string[];
};

export const getLocationGroupIDs = (
  scheduleAssemblies: IScheduleAssembly[] | undefined,
  assemblyIds: number[],
  locationDayParts: IScheduleDaypart[] | undefined,
) => {
  const locationGroupIDs = [
    ...uniq(
      locationDayParts
        ?.filter((dayPart) =>
          scheduleAssemblies
            ?.filter(
              (assembly) =>
                assembly.location_code === null &&
                assemblyIds.includes(assembly.assembly_id),
            )
            .map((assembly) => assembly.daypart_id)
            .includes(dayPart.id),
        )
        .map((dayPart) => dayPart.location_group_id),
    ),
  ];

  return locationGroupIDs;
};
